import React from 'react'
import {Select} from "antd"
import PropTypes from "prop-types"

const {Option} = Select

const SelectSearch = (props) => {
    const {listSelect, name, label} = props

    const _handleChangeSelect = (value) => {
        props.onChange(name, value)
    }

    return (
        <div className="InputSearch">
            {label && <div className="font-weight-500 LabelFilter mb-1">{label}</div>}

            <Select
                style={{width: '100%'}}
                defaultValue=""
                onChange={_handleChangeSelect}
            >
                {
                    listSelect.map(item => {
                        return <Option value={item.value} key={item.value}>{item.name}</Option>
                    })
                }
            </Select>
        </div>
    )
}

SelectSearch.defaultProps = {
    label: '',
    value: ''
}

SelectSearch.propTypes = {
    name: PropTypes.string.isRequired,
    listSelect: PropTypes.array,
    label: PropTypes.string
}

export default SelectSearch
